export default __webpack_public_path__ + "static/headshot1-7037db18042ebec27ab95293eaf82adc.png";